<template>
    <b-card :title="$translate('filters')" class="query-filter filter-form" body-class="p-0 mt-3">
        <div>
            <b-row>
                <b-col cols="12" md="4" class="mt-3">
                    <label for="input-customer" class="mb-3"><strong>{{ $translate('customer')
                    }}</strong></label>
                <customer-type-ahead v-model="filtersModel.customer_id" />
               </b-col>
                <b-col cols="12" md="4" class="mt-3">
                    <label for="input-activity" class="mb-3"><strong>{{ $translate('activity')
                    }}</strong></label>
                    <b-input type="text" :placeholder="$translate('search_activity')" v-model="filtersModel.order_search"></b-input>
                </b-col>
                <b-col cols="12" md="4" class="mt-3">
                    <label for="input-activity" class="mb-3"><strong>{{ $translate('asset')
                    }}</strong></label>
                    <b-input type="text" :placeholder="$translate('search_asset')" v-model="filtersModel.asset_search"></b-input>
                </b-col>
                <b-col md="3" cols="12" class="mt-3 text-start">
                    <label for="input-transaction_start_date" class="mb-3"><strong>{{ $translate('start_from_date') }}</strong></label>
                    <b-form-input type="date" :max="filtersModel.transactionToDate" id="input-start_from_date"
                        v-model="filtersModel.transactionFromDate"></b-form-input>
                </b-col>
                <b-col md="3" cols="12" class="mt-3 text-start">
                    <label for="input-transaction_end_date" class="mb-3"><strong>{{ $translate('start_from_date_to_date') }}</strong></label>
                    <b-form-input type="date" :min="filtersModel.transactionFromDate" id="input-start_from_date_end_date" v-model="filtersModel.transactionToDate"></b-form-input>
                </b-col>
                <b-col cols="12" md="3" class="mt-3 dd">
                    <label class="mb-3"><strong>{{ $translate('is_returned')
                            }}</strong></label>
                    <b-form-select class="form-control" id="input-payment_transaction_status" v-model="filtersModel.is_returned"
                        :options="is_returned_option">
                        <template #first>
                            <b-form-select-option :value="null" selected>
                                {{ $translate('select_option')}}
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col md="3" cols="12" class="mt-3 text-start">
                    <label for="input-outstanding_balance" class="mb-3"><strong>{{$translate('estimated_rental_rate')}}</strong>
                    </label>

                    <b-input-group>
                        <b-form-input id="input-outstanding_balance" type="number"
                            v-model="filtersModel.estimated_rental_rate"></b-form-input>
                        <template #prepend>
                            <div class="customselect">
                                <select class="form-control" v-model="filtersModel.quantityType" value-field="id"
                                    text-field="name" block>
                                    <option v-for="x in quantities" :key="'customselect:--' + x.id" :value="x.id">
                                        {{ x.name }}
                                    </option>
                                </select>
                            </div>
                        </template>
                    </b-input-group>
                </b-col>
               
              
            </b-row>
        </div>
    </b-card>
</template>

<script>
import CustomerTypeAhead from "@/components/CustomerTypeAhead.vue";

export default {
    name: 'rental-filters',
    data(){
        return {

            quantities: [
                { id: 1, name: '=' },
                { id: 2, name: '>' },
                { id: 3, name: '<' },
            ],
            is_returned_option: [
                {
                value: 1,
                text: this.$translate('yes') 
                },
                {
                value: 0,
                text: this.$translate('no') 
                },
            ],
        }
    },  
    props: ['value'],
    components:{CustomerTypeAhead },
    computed: {
        filtersModel: {
            // getter
            get() {
                return this.value
            },
            // setter
            set(val) {
                this.$emit('input', val)
            },
        },

        paymentTransactionStatus() {
            return {
                pending: "Pending",
                processed: "Processed",
                cancelled: "Cancelled"
            }
        },

        transaction_type() {
            return {
                incoming: 'Incoming',
                outgoing: 'Outgoing',
            };
        },
    },

    watch: {},
}
</script>
